function loadFontsFromLocalStorage() {
    let fonts = JSON.parse(localStorage.getItem("cc-font-defaults")) || [];
    let newStyleTag = document.createElement('style');
    fonts.forEach(fontName => {
        
        newStyleTag.appendChild(document.createTextNode(`
        @font-face {
            font-family: ${fontName.name};
            src: local('${fontName.name}');
        }`
        ));
        //console.log(`Loading font: ${fontName.name}`);
    });

    document.head.appendChild(newStyleTag);
    return fonts;
}

// Create reactive state for fonts
export const fontState = $state(loadFontsFromLocalStorage());

// Method to update fontState without direct assignment
// Use this instead of directly assigning to fontState
export function updateFontState(newFontState) {
    // Clear the existing array
    fontState.length = 0;
    
    // Add all items from the new state
    if (Array.isArray(newFontState)) {
        newFontState.forEach(font => fontState.push(font));
    } else if (typeof newFontState === 'string') {
        // Handle case when fontState is updated from JSON string
        const parsedFonts = JSON.parse(newFontState);
        if (Array.isArray(parsedFonts)) {
            parsedFonts.forEach(font => fontState.push(font));
        }
    }
    
    // Optionally, save to localStorage
    localStorage.setItem("cc-font-defaults", JSON.stringify(fontState));
    
    return fontState;
}